<div class="visualization-container" [style.border-color]="borderColor" [style.background-color]="backgroundColor">
  <div class="label-sm">{{ label }}</div>
  <div class="d-flex justify-content-center">
    <div [style.max-height.rem]="7.688" [style.max-width.rem]="7.688">
      <app-donut-chart [data]="donutChartData" />
    </div>
  </div>
  <app-donut-chart-legend [data]="donutChartData" [showTotalRow]="false" />
</div>
